import createStore from "@/utils/create-store";
import Model from "@/models/admin/tree-wishes";

export default createStore({ Model });
